import React from 'react';
import styled from '@emotion/styled';
import iconCheck from '@static/icons/icon-check.png';
import { DotIcon } from '@components/Svg';

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 18px;
  max-width: ${props => (!props.listItemTextNoWrap ? '400px' : null)};
`;
const List = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    margin: 0 0 30px 0;
  }
`;
const ListItem = styled.li`
  position: relative;
  display: flex;
  padding: ${props => (props.showBullets ? '8px 0 8px 40px' : '8px 0')};
  margin: 0;
  align-items: center;
`;
const ListItemIcon = styled.img`
  position: absolute;
  left: 0;
  width: 20px;
`;
const ListItemDotIcon = styled(DotIcon)`
  width: ${props => (props.listItemTextBold ? '8px' : '6px')};
  min-width: ${props => (props.listItemTextBold ? '8px' : '6px')};
  height: ${props => (props.listItemTextBold ? '8px' : '6px')};
  fill: ${props => props.theme.colors.primary.base};
  margin-right: 10px;
`;
const ListTitleText = styled.div`
  font-size: 15px;
  font-weight: 600;
  margin: 10px 0 20px 0;
  color: ${props =>
    props.textHighlighted ? props.theme.colors.primary.base : null};
`;
const ListItemText = styled.span`
  font-size: ${props => (props.listItemTextBold ? '15px' : '13px')};
  font-weight: ${props => (props.listItemTextBold ? '600' : null)};
  color: ${props => props.theme.colors.black.light};
`;

const ItemList = props => {
  return (
    <ListWrapper listItemTextNoWrap={props.listItemTextNoWrap}>
      {props.title ? (
        <ListTitleText textHighlighted={props.titleHighlighted}>
          {props.title}
        </ListTitleText>
      ) : null}
      <List>
        {props.items &&
          props.items.map((item, idx) => (
            <ListItem
              showBullets={!!props.listStyle && props.listStyle != 'dot'}
              key={idx}
            >
              {props.listStyle == 'check' ? (
                <ListItemIcon
                  src={iconCheck}
                  listItemTextBold={props.listItemTextBold}
                />
              ) : null}
              {props.listStyle == 'dot' ? <ListItemDotIcon /> : null}
              <ListItemText listItemTextBold={props.listItemTextBold}>
                {item}
              </ListItemText>
            </ListItem>
          ))}
      </List>
    </ListWrapper>
  );
};

export default ItemList;
